export const CURRENT_WEEK = 0;
export const NEXT_WEEK = 1;
export const PREVIOUS_WEEK = -1;
export const PREVIOUS_WEEK_MIN = -1;
export const NEXT_WEEK_MAX = 3;
export const ADMIN_ROLE = 2;
export const DEFAULT_ROLE = 1;
export const CATERING_ROLE = 3;
export const DEFAULT_OFFICE = 2; // GDL for startupGDLers
export const DEFAULT_COMPANY = 1; // All
export const EXTRAS_ID = 5;
export const EXTRAS_NAME = 'Extras';
export const FEEDBACK_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLScVy80G1LfRZhipePWIEYDqKpuH4zGYB1dvABnCd_dfp6MV6Q/viewform';
export const FEEDBACK_CATERING_FORM =
  'https://docs.google.com/forms/d/e/1FAIpQLSfGPliwiWmgQWYkaqpgmdHQ_sYzn2O4e6I83VduGSsD0br4Tw/viewform';
export const DEFAULT_OFFICE_NAME = 'Guadalajara 1';
export const WEEK_FORMAT_STRING = 'GGGG-WW';

export const auth0LocalStorageKey = 'auth0Auth';

export const cateringSettingsKey = 'cateringSettings';
export const cateringDataKey = 'cateringData';

export const cateringSettingsDefaults = {
  OFFICE: 2, // GDL
  EVENT: 1,
  DIETS: [1, 2, 3],
};

export const Role = {
  COMMON: 1,
  ADMIN: 2,
  CATERING: 3,
};

export const ISSUERS = {
  AUTH0: 'auth0',
};

export const ROUTES = {
  HOME: '/',
  MENU: '/menu',
  SETTINGS: '/settings',
  REPORTS: '/reports',
  CATERING: '/catering',
  UNAUTHORIZED: '/unauthorized',
  CATERING_SETTINGS: '/catering/settings',
};

export const ROUTE_NAMES = {
  ADMIN: 'Admin',
  AUTH_CALLBACK: 'AuthCallback',
  AUTH0_CALLBACK: 'Auth0Callback',
  SETTINGS: 'Settings',
  REPORTS: 'Reports',
  WEEKLY_MENU: 'WeeklyMenu',
  WELCOME_PAGE: 'Homepage',
  CATERING_LANDING: 'Catering',
  CATERING_SETTINGS: 'CateringSettings',
};
export const FROM_THIS_MONDAY = {
  toThisMonday: 1,
  toThisFriday: 5,
  toNextMonday: 8,
  toNextFriday: 12,
  toNextWeek: 7,
};
export const MESSAGE_TYPES = {
  ERROR: 'error',
  SUCCESS: 'success',
  MODAL: 'modal',
};
export const DAY_LIST = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
export const GOOGLE_SHEETS_TEMPLATES =
  'https://docs.google.com/spreadsheets/u/0/?ftv=1&folder=0ANnI2oF8RB9VUk9PVA&tgif=d';
export const BAMBOOHR_CSV_EXPORT =
  'https://wizeline.bamboohr.com/employees/exportable_org_chart/csv/general_csv';
export const FOODIE_VERSION = process.env.FOODIE_VERSION;

export const NAVIGATION_ACCESS_KEYS = {
  navbar: {
    accessKeysModal: '0',
    home: '1',
    settings: '2',
    reports: '3',
    logout: '4',
  },
  weekNav: {
    'previous week': '5',
    'next week': '6',
  },
  noMealsInWeekByEventShortcuts: {
    meals: '7',
    breakfast: '8',
    lunch: '9',
  },
  weekDays: {
    monday: 'q',
    tuesday: 'w',
    wednesday: 'e',
    thursday: 'r',
    friday: 't',
  },
  dietaryOptionsFilter: {
    regular: 'y',
    light: 'u',
    vegan: 'i',
    vegetarian: 'o',
    extras: 'p',
  },
  menu: {
    breakfast: {
      none: 'a',
      regular: 's',
      vegan: 'd',
      light: 'f',
      vegetarian: 'g',
    },
    lunch: {
      none: 'h',
      regular: 'j',
      vegan: 'k',
      light: 'l',
      vegetarian: 'z',
    },
    sendOrder: 'm',
  },
};

export const CATERING_CONFIRMATION_INTENTIONS = {
  success: 'success',
  userNotInTheList: 'userNotInTheList',
  incorrectMealType: 'incorrectMealType',
  notRegisteredMeals: 'notRegisteredMeals',
  mealAlreadyServed: 'mealAlreadyServed',
  wrongOffice: 'wrongOffice',
};

export const CATERING_CONTACT = ['@VaneDLA', '@elbz', '@eder'];

export const DIET_TYPES = ['regular', 'light', 'vegan', 'vegetarian'];



// WEBPACK FOOTER //
// ./src/constants/index.js